import PublishingSection from '../../../sections/AdminDashboard/Configuration/Publishing';

const Publishing = () => <PublishingSection />;

export default Publishing;
